"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableContainer = exports.DraggableList = exports.FormattedTBodyContainer = exports.FormattedDivContainer = void 0;
var React = __importStar(require("react"));
var array_move_1 = __importDefault(require("array-move"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var styled_components_1 = __importStar(require("styled-components"));
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.tws-draggable-row {\n\t\tz-index: 1050;\n\t}\n"], ["\n\t.tws-draggable-row {\n\t\tz-index: 1050;\n\t}\n"])));
exports.FormattedDivContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) {
    return props.isDisabled
        ? "\n\t\t\t.draggable-handle {\n\t\t\t\tbackground-color: #999999;\n\t\t\t\tcursor: default;\n\t\t\t}"
        : '';
});
exports.FormattedTBodyContainer = styled_components_1.default.tbody.attrs(function (props) { return ({
    className: '',
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) {
    return props.isDisabled
        ? "\n\t\t\t.draggable-handle {\n\t\t\t\tbackground-color: #999999;\n\t\t\t\tcursor: default;\n\t\t\t}"
        : "\n\t\t\t&.tws-draggable-table {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tmargin-bottom: 6px;\n\t\t\t}\n\t\t";
});
exports.DraggableList = (0, react_sortable_hoc_1.SortableContainer)(function (props) {
    return props.isTable ? (React.createElement(exports.FormattedTBodyContainer, { isDisabled: props.disabled }, props.children)) : (React.createElement(exports.FormattedDivContainer, { isDisabled: props.disabled, "data-testid": 'tws-drag-container' }, props.children));
});
var DraggableContainer = /** @class */ (function (_super) {
    __extends(DraggableContainer, _super);
    function DraggableContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onSortEnd = function (_a) {
            var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
            if (!_this.props.disabled) {
                var items = (0, array_move_1.default)(_this.props.items, oldIndex, newIndex);
                var primaryKey_1 = _this.props.primaryKey !== undefined ? _this.props.primaryKey : 'id';
                _this.props.onChange(items.map(function (item) { return item[primaryKey_1]; }));
            }
        };
        return _this;
    }
    DraggableContainer.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(exports.DraggableList, { useDragHandle: true, disabled: this.props.disabled, onSortEnd: this.onSortEnd, lockAxis: 'y', helperClass: 'tws-draggable-row', isTable: this.props.isTable, updateBeforeSortStart: this.props.updateBeforeSortStart }, this.props.children)));
    };
    return DraggableContainer;
}(React.Component));
exports.DraggableContainer = DraggableContainer;
var templateObject_1, templateObject_2, templateObject_3;
